import React from 'react';

const TermsAndConditions = () => {
    return (
        <div className="md:px-8 px-3 bg-white pt-40">
            <h1 className="text-2xl font-grifter text-[#273046] mb-6">Majorlink Terms and Conditions</h1>
            
            <p className="font-aeonikregular text-sm mb-6">
                Welcome to Majorlink. These terms and conditions outline the rules and regulations for the use of Majorlink's cryptocurrency trading services and platform.
            </p>

            <p className="font-aeonikregular text-sm mb-6">
                By accessing and using our platform, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by these terms, please do not use our services.
            </p>

            <p className="font-aeonikregular text-sm mb-6">
                Registration: To use our services, you must register on our platform and provide accurate, up-to-date information. It's crucial to keep your account details confidential. You are responsible for all activities on your account.
            </p>

            <p className="font-aeonikregular text-sm mb-6">
                Transactions: Majorlink provides a platform for buying and selling cryptocurrencies. We are not responsible for any losses or gains you might experience as the value of cryptocurrencies can be volatile. Please trade responsibly.
            </p>

            <p className="font-aeonikregular text-sm mb-6">
                Fees: Majorlink may charge fees for transactions. These will be outlined clearly in our platform's fee structure. Fees are subject to change and will be updated on our platform.
            </p>

            <p className="font-aeonikregular text-sm mb-6">
                Risk: Cryptocurrency trading is subject to risks. Please consult financial advisors and make informed decisions.
            </p>

            <p className="font-aeonikregular text-sm mb-6">
                Termination: We reserve the right to terminate or suspend any account if we detect unlawful activities or breaches of these terms.
            </p>

            <p className="font-aeonikregular text-sm mb-6">
                Privacy: We respect user privacy and handle all user data in accordance with our privacy policy. Please review it for more details.
            </p>

            <p className="font-aeonikregular text-sm mb-6">
                Limitation of Liability: Majorlink is not responsible for any damages or losses related to the use of our services. Our platform is provided "as is", without any guarantees.
            </p>

            <p className="font-aeonikregular text-sm mb-6">
                Amendments: We reserve the right to update these terms and conditions without prior notice. It's your responsibility to review them periodically.
            </p>

            <p className="font-aeonikregular text-sm mb-6">
                Governing Law: These terms and conditions are governed by and construed in accordance with the laws of [Country/State] and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.
            </p>

            {/* ... continue with more terms as needed ... */}
        </div>
    );
}

export default TermsAndConditions;
